import { render } from "./notification-card.vue?vue&type=template&id=609fc17a&scoped=true"
import script from "./notification-card.vue?vue&type=script&lang=js"
export * from "./notification-card.vue?vue&type=script&lang=js"

import "./notification-card.vue?vue&type=style&index=0&id=609fc17a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609fc17a"]])

export default __exports__